//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from "~/mixins/SEO.js";
import JSONSCHEMA from "~/mixins/JSONSCHEMA.js";
import Multiselect from "vue-multiselect";
export default {
  name: "index",
  mixins: [SEO, JSONSCHEMA],
  components: {
    Multiselect,
  },

  data: () => ({
    genderList: [
      {
        id: 0,
        title: "",
      },
      {
        id: 1,
        title: "",
      },
    ],

    basal: {
      gender: null,
      age: null,
      weight: null,
      height: null,
      formActive: true,
      result: "",
    },
    //body fat percentage
    bfp: {
      gender: null,
      genderGap: null,
      age: null,
      bmi: null,
      formActive: true,
      result: "",
    },

    bmi: {
      weight: null,
      height: null,
      formActive: true,
      result: "",
      status: "",
    },

    water: {
      weight: null,
      exercise: null,
      formActive: true,
      result: "",
    },

    calorie: {
      gender: null,
      age: null,
      weight: null,
      height: null,
      formActive: true,
      result: "",
    },

    ibw: {
      gender: null,
      height: null,
      formActive: true,
      result: "",
    },

    pregnancy: {
      dateToday: null,
      formActive: true,
      result: "",
    },
  }),

  methods: {
    calcBasal() {
      if (this.basal.gender.title == this.genderList[0].title) {
        this.basal.result = Math.round(
          10 * this.basal.weight +
          6.25 * this.basal.height -
          5 * this.basal.age +
          5
        );
      } else {
        this.basal.result = Math.round(
          10 * this.basal.weight +
          6.25 * this.basal.height -
          5 * this.basal.age -
          161
        );
      }
      this.basal.formActive = false;
    },

    calcBasalReset() {
      this.basal.gender = null;
      this.basal.age = null;
      this.basal.weight = null;
      this.basal.height = null;
      this.basal.formActive = true;
    },
    //Body fat percentage
    calcbfp() {
      //For children
      if (this.bfp.age <= 15) {
        if (this.bfp.gender.title == this.genderList[0].title) {
          this.bfp.result = Math.round(
            1.51 * this.bfp.bmi - 0.7 * this.bfp.age - 3.6 * 1 + 1.4
          );
        }
        if (this.bfp.gender.title == this.genderList[1].title) {
          this.bfp.result = 1.51 * this.bfp.bmi - 0.7 * this.bfp.age - 3.6 * 0 + 1.4;
        }
      }
      //For adults
      else {
        if (this.bfp.gender.title == this.genderList[0].title) {
          this.bfp.result = Math.round(
            1.39 * this.bfp.bmi - 0.16 * this.bfp.age - 10.34 * 1 - 9
          );
        }
        if (this.bfp.gender.title == this.genderList[1].title) {
          this.bfp.result = Math.round(
            1.39 * this.bfp.bmi - 0.16 * this.bfp.age - 10.34 * 0 - 9
          );
        }
      }
      this.bfp.formActive = false;
    },
    calcbfpReset() {
      (this.bfp.gender = null),
        (this.bfp.age = null),
        (this.bfp.bmi = null),
        (this.bfp.formActive = true),
        (this.bfp.result = "");
    },
    calcBmi() {
      this.bmi.result = (
        this.bmi.weight / Math.pow(this.bmi.height / 100, 2)
      ).toFixed(1);
      if (this.bmi.result < 18.5) {
        this.bmi.status = `${this.$i18n.t("calculatorPage.bmi.underweight")}😒`;
      } else if (this.bmi.result >= 18.5 && this.bmi.result <= 24.9) {
        this.bmi.status = `${this.$i18n.t(
          "calculatorPage.bmi.normalWeight"
        )} 😍`;
      } else if (this.bmi.result >= 25 && this.bmi.result <= 29.9) {
        this.bmi.status = `${this.$i18n.t("calculatorPage.bmi.overweight")} 😮`;
      } else {
        this.bmi.status = `${this.$i18n.t("calculatorPage.bmi.obese")} 😱`;
      }
      this.bmi.formActive = false;
    },

    calcBmiReset() {
      this.bmi.weight = null;
      this.bmi.height = null;
      this.bmi.formActive = true;
    },

    calcWater() {
      this.water.result = (
        (this.water.weight / 2 + (this.water.exercise / 30) * 12) /
        16.9
      ).toFixed(2);
      this.water.formActive = false;
    },

    calcWaterReset() {
      this.water.weight = null;
      this.water.exercise = null;
      this.water.formActive = true;
    },

    calcCalorie() {
      if (this.calorie.gender.id == 0) {
        this.calorie.result = (
          88.362 +
          13.39 * this.calorie.weight +
          4.799 * this.calorie.height -
          5.67 * this.calorie.age
        ).toFixed(2);
      } else {
        this.calorie.result = (
          444.59 +
          9.24 * this.calorie.weight +
          3.09 * this.calorie.height -
          4.33 * this.calorie.age
        ).toFixed(2);
      }
      this.calorie.formActive = false;
    },

    calcCalorieReset() {
      this.calorie.gender = null;
      this.calorie.age = null;
      this.calorie.weight = null;
      this.calorie.height = null;
      this.calorie.formActive = true;
    },

    calcIbw() {
      if (this.ibw.gender.id == 0) {
        this.ibw.result = (48 + 1.1 * (this.ibw.height - 150)).toFixed(2);
      } else {
        this.ibw.result = (45 + 0.9 * (this.ibw.height - 150)).toFixed(2);
      }
      this.ibw.formActive = false;
    },

    calcIbwReset() {
      this.ibw.height = null;
      this.ibw.gender = null;
      this.ibw.formActive = true;
    },

    calcPregnancy() {
      this.pregnancy.result = this.$moment(this.pregnancy.dateToday, "YYYYMMDD")
        .locale(`${this.$i18n.locale}`, null)
        .add(280, "days")
        .format("Do MMMM YYYY");
      this.pregnancy.formActive = false;
    },

    calcPregnancyReset() {
      this.pregnancy.dateToday = null;
      this.pregnancy.formActive = true;
    },
  },

  async asyncData({ app, params, error }) {
    try {
      const response = await app.$api.fetchSingleCalculator(params.slug);
      return { page: response.content };
    } catch (e) {
      error({ statusCode: 404 });
    }
  },

  created() {
    this.genderList[0].title = this.$i18n.t("calculatorPage.male");
    this.genderList[1].title = this.$i18n.t("calculatorPage.female");
  },
};
